import { Command } from "commander";
import consola from "consola";

import { genCommand } from "@/commands/gen.js";
import pkg from "../package.json";
import { configCommand } from "./commands/config";
import { historyCommand } from "./commands/history";

async function main() {
  const program = new Command()
    .name("gmana")
    .description("🔐 A modern password generator CLI")
    .version(pkg.version, "-v, --version", "display version number")
    .helpOption("-h, --help", "display help for command");

  program.addCommand(genCommand).addCommand(configCommand).addCommand(historyCommand);

  program.exitOverride();

  try {
    await program.parseAsync();
  } catch (error) {
    if (error instanceof Error && error.name === "CommanderError") {
      process.exit(0);
    }

    consola.error("Unexpected error:", error instanceof Error ? error.message : error);
    process.exit(1);
  }
}

main();
